import { AccountAvatar } from '@/features/AccountAvatar';
import { FeedbackBlankError } from '@/shared/components/FeedbackBlank';
import { Layout } from '@/shared/components/Layout';

export const OrderNotFound = () => (
    <Layout accountSlot={<AccountAvatar />}>
        <FeedbackBlankError
            title="Заказ не найден"
            subtitle=" Вы перешли по неправильной ссылке или страница была удалена"
        />
    </Layout>
);
